import axios from '@/axios';
import { fetchClinics } from './clinic';
import { findKeyValue } from '@/utils/objectHelpers';
import { getLocalStorageItem } from '@/utils/localStorageHelpers';

const token = getLocalStorageItem('AccessToken');
const authHeader = { Authorization: token };

/**
 * Fetch agreement logs for a specific clinic
 * @param {string} clinicId - The clinic ID
 * @returns {Promise<Object>} - Agreement logs data
 */
export const fetchAgreementLogs = async (clinicId) => {
  const { data } = await axios.get(`/api/v2/agreement-logs?clinicId=${clinicId}`, {
    headers: authHeader,
  });
  return data;
};

/**
 * Fetch and check agreement status for a clinic
 * @param {string} organizationId - The organization ID
 * @returns {Promise<boolean>} - True if all agreements are accepted, false otherwise
 */
export const fetchAgreementStatus = async (organizationId) => {
  let clinicId = null;

  try {
    // Fetch clinics under the organization
    const { data: { data: clinics } } = await fetchClinics(organizationId);
    clinicId = findKeyValue(clinics, 'clinicId');

    if (!clinicId) {
      console.error('No clinics found for the organization.');
      return null; 
    }
  } catch (error) {
    console.error('Error fetching clinics for the organization:', error);
    return null;
  }

  try {
    // Fetch agreement status for the clinic
    const { data } = await fetchAgreementLogs(clinicId);

    // Check if the response data is an empty object
    if (Object.keys(data).length === 0) {
      console.error('Agreement logs returned an empty object.');
      return null; // Disable redirecting to contract-agreement page
    }

    const clinicAgreementStatus = findKeyValue(data, 'clinicAgreement');
    const termsConditionStatus = findKeyValue(data, 'termsConditions');
    const eulaAgreementStatus = findKeyValue(data, 'eulaAgreement');

    return clinicAgreementStatus && termsConditionStatus && eulaAgreementStatus;
  } catch (error) {
    console.error('Error fetching agreement status:', error);
    return null;
  }
};

